import { render, staticRenderFns } from "./FlatDatePicker.vue?vue&type=template&id=08a9445a&"
import script from "./FlatDatePicker.vue?vue&type=script&lang=js&"
export * from "./FlatDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports